<template>
  <div class="app-main-content finance-report">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" :lazy="true" type="card" style="width:100%;">
        <el-tab-pane :label="'Finance Report'" name="financeReport">
          <tab-finance-report ref="financeReport" :copy-month-list="copyMonthList" :latest-monthly-date="latestMonthlyDate" />
        </el-tab-pane>
      </el-tabs>O
    </div>
  </div>
</template>

<script>
import tabFinanceReport from './tabFinanceReport'
import { getLoading } from '@/utils/utilBaseElement'
import { loadSearchConditions2Report } from '@/api/clearing/pillReport'

export default {
  name: 'FinanceReport',
  components: { tabFinanceReport },
  props: {},
  data() {
    return {
      loading: false,
      activeTabName: 'financeReport',
      copyMonthList: [], // copy Month列表
      latestMonthlyDate: null // 最新月度数据生成时间
    }
  },
  created() {
    this.loadInitData()
  },
  methods: {
    loadInitData() {
      this.loading = getLoading()
      loadSearchConditions2Report({ 'hrMark': false }).then(res => {
        if (res.data) {
          this.copyMonthList = res.data.copyMonthList
          this.latestMonthlyDate = res.data.latestMonthlyDate
          this.$nextTick(() => {
            this.$refs.financeReport.setDefaultCondition()
          })
        }
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style lang="scss">

</style>
